const Desc = `smartObjectV2: PSB input file in cc, replace high res image in CC, save as JPEG. ${new Error('To get file path').stack.split('\n')[1].match(/Object(.+)\(https/)[1] || ''}`

const Payload = {
    inputs: [
        {
            href: 'files/_skycity_smoketest/AUTOBLUR_l_small.psb',
            storage: 'adobe'
        }
    ],
    options: {
        layers: [
            {
                id: 7,
                input: {
                    href: 'files/_skycity_smoketest/Seeing Chanel_small.png',
                    storage: 'adobe'
                }
            }
        ]
    },
    outputs: [
        {
            storage: 'adobe',
            type: 'image/jpeg',
            overwrite: true,
            width: 300,
            quality: 5,
            href: 'temp/015c2948-73c6-4256-9d10-ee9d12cbff12/AUTOBLUR_l_small_300_1.jpeg'
        }
    ]
}

module.exports = { Payload, Desc }
